import {Field} from 'formik';
import {FormikTextarea} from '@shipwell/shipwell-ui';

const MessageToCustomerField = () => {
  return <Field label="Message to Customer" name="notes" component={FormikTextarea} required={false} />;
};
export default MessageToCustomerField;
